<div class="one3d-scrollable-wrapper-custom">
  <!--accessories desc-->
  <div class="one3d-acc-description-new">
    <p>
      <b>Disclaimer</b>:
      {{ showMoreDesc ? accDisclaimer : (accDisclaimer | slice : 0 : 150) }}
      <span (click)="showMoreDesc = !showMoreDesc">
        {{ showMoreDesc ? "Show less" : "Show More" }}
      </span>
    </p>
  </div>
  <!--accessories desc-->

  <div *ngFor="let accessories of accessoriesList">
    <div class="one3d-acc">
      <div class="one3d-acc-name">{{ accessories.subgroup_name }}</div>
      <button
        class="one3d-acc-card one3d-acc-card-new"
        *ngFor="let accessory of accessories.subgroupAccessories"
      >
        <div class="one3d-acc-img-section">
          <img
            (click)="
              addAccessory(
                accessory,
                accessoriesService.ifAccessoryAddedInPack(accessory)
              )
            "
            class="one3d-acc-img"
            [src]="
              accessory.thumb_url
                ? accessory.thumb_url
                : 'assets/img/one3d-acc-image.png'
            "
            alt="Accessory image"
          />
          <div class="one3d-3d-overlay" *ngIf="accessory.is_3d === 'yes'">
            <img
              class="one3d-3d-icon"
              src="assets/img/icons/one3d-3d-icon.svg"
              alt="3d icon"
            />
          </div>
        </div>
        <div class="one3d-acc-content">
          <div class="one3d-acc-content-heading-new">
            <p class="one3d-acc-content-title">
              {{ accessory.marketing_name }}
            </p>
            <span class="one3d-info-icon" *ngIf="accessory.accessories_desc">
              <button (click)="viewDetails(accessory)">
                <img
                  class="one3d-info-icon"
                  [src]="
                    accessory.viewDetails
                      ? 'assets/img/icons/one3d-minus-icon.svg'
                      : 'assets/img/icons/one3d-info-icon.svg'
                  "
                  alt="info icon"
                />
              </button>
            </span>
          </div>

          <div class="one3d-acc-content-bottom">
            <p class="one3d-acc-content-price">
              {{ globalService.currencyFormatter(accessory.price) }}
            </p>
            <button
              class="one3d-acc-add-btn"
              *ngIf="!accessoriesService.accessoryAdded(accessory)"
              (click)="
                addAccessory(
                  accessory,
                  accessoriesService.ifAccessoryAddedInPack(accessory)
                )
              "
              translate
            >
              ACCESSOR_LISTING.ADD
            </button>
            <button
              class="one3d-acc-remove-btn"
              *ngIf="accessoriesService.accessoryAdded(accessory)"
              (click)="removeAccessory(accessory)"
              translate
            >
              ACCESSOR_LISTING.REMOVE
            </button>
          </div>
        </div>
        <!--accessories desc-->
        <div *ngIf="accessory.viewDetails" class="one3d-acc-desc-new">
          <p *ngIf="accessory.accessories_desc">
            <i
              [innerHTML]="
                showMore
                  ? getSanitizedDynamicText(accessory.accessories_desc)
                  : (getSanitizedDynamicText(accessory.accessories_desc)
                    | slice : 0 : 300)
              "
            >
            </i>
            <span (click)="showMore = !showMore">
              {{ showMore ? "Show less" : "Show More" }}
            </span>
            <!-- commented as content coming with html tags, can't show directly -> call getSanitizedDynamicText -->
            <!-- {{
              showMore
                ? accessory.accessories_desc
                : (accessory.accessories_desc | slice : 0 : 300)
            }} -->
          </p>
        </div>
        <!--accessories desc-->
      </button>
    </div>
  </div>
</div>
